<mat-card>

    <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
    <mat-label *ngIf="!isSearching && msgError?.length > 0">{{msgError}}</mat-label>

    <div *ngIf="!isSearching && item != null">

        <mat-card-content>
            <div [innerHTML]="tituloHtml" class="mat-card-content-title"></div>

            <div fxLayout="row stretch" fxLayout.xs="column" fxLayoutAlign="space-between center">
                <div fxFlex="50" fxFlex.xs="100">
                    <img *ngIf="item.ImagenPortadaUrl" [src]="item.ImagenPortadaUrl" class="mat-card-content-img-portada">
                    <img *ngIf="!item.ImagenPortadaUrl" src="../../../../assets/edificio.default.webp" class="mat-card-content-img-portada">
                </div>
                <div fxFlex="50" fxFlex.xs="100">
                    <div [innerHTML]="descripcionHtml"></div>
                </div>
            </div>

            <div fxLayout="row stretch" fxLayout.xs="column">
                <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin:0px 0px; padding-top: 16px;">
                    <mat-label><b>ADJUNTOS:</b></mat-label>
                </div>
                <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin:10px;" *ngIf="isAttachmentSearching">
                    <mat-label><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
                </div>
                <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin:10px;" *ngIf="!isAttachmentSearching">
                    <mat-nav-list>
                      <mat-list-item *ngFor="let file of item.Adjuntos" style="background-color: lightgray; margin: 5px 0px;border-radius: 10px;">
                          <a matLine href="{{file.UrlDocumento}}" target="_blank">{{file.NombreDocumento}}</a>
                      </mat-list-item>
                    </mat-nav-list>
                </div>
            </div>
        </mat-card-content>

        <mat-card-actions style="margin-bottom: 20px;">
            <div fxLayout="row stretch" fxLayout.xs="column">
                <button mat-raised-button (click)="onCancel()" color="warn" class="zb-button">Atrás</button>
            </div>
        </mat-card-actions>

    </div>  

</mat-card>